import styled from '../../../styles/styledComponents/themeComponents';
import Panel from '../../../components/outline/Panel';
import FixedBottomNavBar from '../../../components/FixedBottomNavBar';

export const OrderCreateStyle = styled(Panel)``;

export const TableContainerStyle = styled.div`
  overflow-x: scroll;
`;

export const UploadInfoStyle = styled.div`
  margin-bottom: 20px;

  .upload-count {
    display: flex;
    gap: 5px;

    & > div {
      padding: 10px 0;
      width: 185px;
      font-size: 16px;
      font-weight: 700;

      .possible-count {
        color: #00e424;
      }
      .impossible-count {
        color: #ff001f;
      }
    }
  }

  .upload-controls {
    display: flex;
    gap: 40px;
    align-items: center;
    margin-top: 20px;

    .impossible-count-toggle {
      display: flex;
      gap: 7px;
      align-items: center;

      label {
        flex-shrink: 0;
      }
    }

    .delete-button {
    }

    .guide-message {
      color: #6200ea;
    }

    .button-wrap {
      display: flex;
      align-items: center;
      margin-left: auto;
      gap: 15px;
    }
  }
`;

export const BottomBarStyle = styled(FixedBottomNavBar)`
  display: flex;
  flex-direction: row-reverse;
`;
